export type AdsProvider = "gromore" | "taku" | "mock";

type RuntimeConfig = {
    ADFARM_API_BASE_URL?: string;
    ADFARM_APP_ID?: string;
    ADFARM_ADS_PROVIDER?: AdsProvider;
    ADFARM_GROMORE_PLACEMENT_ID?: string;
    ADFARM_TAKU_PLACEMENT_ID?: string;
    ADFARM_RISK_DISABLED?: boolean | string;
};

function runtimeConfig(): RuntimeConfig {
    const host = globalThis as unknown as {
        __ADFARM_CONFIG__?: RuntimeConfig;
        process?: { env?: RuntimeConfig };
    };
    return { ...(host.process?.env || {}), ...(host.__ADFARM_CONFIG__ || {}) };
}

const env = runtimeConfig();
const riskDisabled = env.ADFARM_RISK_DISABLED === true || env.ADFARM_RISK_DISABLED === "true";
const webOrigin = typeof globalThis.location !== "undefined" && /^https?:$/.test(globalThis.location.protocol)
    ? globalThis.location.origin
    : "http://127.0.0.1:3210";

export const AdFarmConfig = {
    // The hosted Web build uses its own origin so Nginx can proxy /api
    // without CORS or HTTPS mixed-content problems. Android injects its
    // explicit local-test URL before this bundle loads.
    API_BASE_URL: (env.ADFARM_API_BASE_URL || webOrigin).replace(/\/$/, ""),
    APP_ID: env.ADFARM_APP_ID || "main-app",
    ADS_PROVIDER: env.ADFARM_ADS_PROVIDER || "gromore" as AdsProvider,
    GROMORE_PLACEMENT_ID: env.ADFARM_GROMORE_PLACEMENT_ID || "",
    TAKU_PLACEMENT_ID: env.ADFARM_TAKU_PLACEMENT_ID || "",
    RISK_DISABLED: riskDisabled,
    CALLBACK_ATTEMPTS: 45,
    CALLBACK_INTERVAL_MS: 2000,
    OVERVIEW_REFRESH_MS: 15000,
    APP_VERSION_NAME: "1.0.0",
    APP_VERSION_CODE: 1,
    get placementId(): string {
        return this.ADS_PROVIDER === "taku" ? this.TAKU_PLACEMENT_ID : this.GROMORE_PLACEMENT_ID;
    },
};
